"use client";

import { forwardRef, type InputHTMLAttributes } from "react";
import { isAriaInvalid, useFormFieldA11y } from "./form-field";

export interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  className?: string;
}

/** A native text input. Pair with FormField or provide aria-label/aria-labelledby. */
export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
  { type = "text", className, style, id, required, "aria-describedby": describedBy, "aria-invalid": invalid, ...rest },
  ref,
) {
  const a11y = useFormFieldA11y({ id, required, describedBy, invalid });
  const invalidState = isAriaInvalid(a11y["aria-invalid"]);
  return (
    <input
      ref={ref}
      type={type}
      className={`w-full border bg-background text-text-primary placeholder:text-text-secondary focus-visible:outline-none focus-visible:ring-[length:var(--ui-feedback-focus-ring-width)] focus-visible:ring-offset-[var(--ui-feedback-focus-ring-offset)] disabled:cursor-not-allowed disabled:bg-surface disabled:opacity-[var(--ui-feedback-disabled-opacity)] ${invalidState ? "border-danger focus-visible:ring-danger" : "border-border focus-visible:ring-focus-ring"} ${className ?? ""}`}
      style={{
        ...style,
        minHeight: `max(var(--ui-minimum-control-height), var(--ui-field-min-height))`,
        borderRadius: "var(--ui-field-radius)",
        paddingInline: "var(--ui-field-padding-x)",
        paddingBlock: "var(--ui-field-padding-y)",
        fontSize: "var(--ui-field-font-size)",
      }}
      {...a11y}
      {...rest}
    />
  );
});
